import React, { useEffect, useState } from 'react';
import { Clock, ArrowRight } from 'lucide-react';
import { useCountdown } from '../lib/countdown';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const {
    formatted
  } = useCountdown();
  useEffect(() => {
    const onScroll = () => {
      // Show after the user scrolls past ~70% of the viewport height
      const threshold = window.innerHeight * 0.7;
      setVisible(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed left-0 right-0 bottom-0 z-50 px-3 pb-3 sm:px-4 sm:pb-4 pointer-events-none transition-all duration-500 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full'}`} aria-hidden={!visible} data-id="element-57">
      <div className="max-w-2xl mx-auto pointer-events-auto" data-id="element-58">
        <a href="https://pay.hotmart.com/I106053932U" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-between gap-3 bg-terracotta hover:bg-terracotta-dark text-white rounded-2xl shadow-2xl shadow-terracotta/40 px-4 sm:px-5 py-3 sm:py-4 transition-all duration-300 hover:-translate-y-1 border border-white/20" data-id="element-59">
          {/* Left: countdown */}
          <div className="flex items-center bg-white/15 rounded-xl px-3 py-2 backdrop-blur-sm shrink-0" data-id="element-60">
            <Clock className="w-4 h-4 mr-2 shrink-0" data-id="element-61" />
            <span className="font-mono font-bold text-base sm:text-lg tabular-nums flash-white leading-none" data-id="element-62">
              {formatted}
            </span>
          </div>

          {/* Center: label */}
          <div className="flex-1 min-w-0 text-center sm:text-left" data-id="element-63">
            <p className="font-bold text-sm sm:text-base leading-tight" data-id="element-64">
              ¡Comenzar Ya!
            </p>
            <p className="text-[10px] sm:text-xs text-white/85 leading-tight" data-id="element-65">
              $37 USD · Pago único
            </p>
          </div>

          {/* Right: arrow */}
          <div className="shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white/30 transition-colors" data-id="element-66">
            <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-0.5 transition-transform" data-id="element-67" />
          </div>
        </a>
      </div>
    </div>;
}